import { Box, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import { formatPublishedDate } from "./pdf-formatters"
import { PdfAuthorNote } from "./pdf-author-note"
import { SummaryBadge } from "./summary-badge"
import { VersionInfoRow } from "./version-info-row"

export function PdfCoverHeader({ title, code, versionInfo, summary, titleNote }) {
    const info = versionInfo ?? {}
    const newVersionPublishedLabel = info.isPublished ? formatPublishedDate(info.newVersionPublished) : "Pending"

    return (
        <Box sx={{ mb: "18px", pageBreakInside: "avoid", breakInside: "avoid" }}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={3}>
                <Box sx={{ pt: "2px" }}>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: "16px",
                            lineHeight: 1.3,
                            color: "#1f2937",
                            mb: "8px",
                        }}
                    >
                        {title || "Untitled Schedule"}
                    </Typography>
                    <Typography sx={{ fontSize: "10px", lineHeight: 1.4, color: "#7b8794" }}>
                        <Box component="span" sx={{ fontWeight: 700, color: "#4b5563" }}>
                            Version:
                        </Box>{" "}
                        {formatVersionDisplay(info)}&nbsp;&nbsp;&nbsp;
                        <Box component="span" sx={{ fontWeight: 700, color: "#4b5563" }}>
                            Code:
                        </Box>{" "}
                        #{code || "—"}
                    </Typography>
                    <Box sx={{ mt: "10px" }}>
                        <VersionInfoRow
                            label="Previous version published"
                            value={formatPublishedDate(info.previousVersionPublished)}
                        />
                        <VersionInfoRow label="New version published" value={newVersionPublishedLabel} />
                        <VersionInfoRow label="PDF generated" value={formatPublishedDate(info.generatedAt)} />
                    </Box>
                    <Typography sx={{ fontSize: "11px", lineHeight: 1.4, color: "#1f2937", mt: "16px" }}>
                        Authoring Changes Review Document
                    </Typography>
                </Box>
                <If value={summary}>
                    <Stack alignItems="flex-end" spacing={1} sx={{ minWidth: "170px" }}>
                        <Typography sx={{ fontSize: "10px", fontWeight: 700, lineHeight: 1.2, color: "#374151" }}>
                            CHANGE SUMMARY
                        </Typography>
                        <Stack direction="row" spacing={3.5} sx={{ mt: "2px" }}>
                            <SummaryBadge label="Total Tasks" count={summary.totalTasks} color="#374151" />
                            <SummaryBadge label="New" count={summary.newTasks} color="#299c46" />
                            <SummaryBadge label="Modified" count={summary.modifiedTasks} color="#2b95a2" />
                            <SummaryBadge label="Removed" count={summary.removedTasks} color="#d64747" />
                        </Stack>
                    </Stack>
                </If>
            </Stack>
            <If value={!!titleNote?.content}>
                <Box sx={{ mt: "12px" }}>
                    <PdfAuthorNote note={titleNote} />
                </Box>
            </If>
            <Box sx={{ borderBottom: "1px solid #d7dce2", mt: "14px" }} />
        </Box>
    )

    function formatVersionDisplay({ previousVersion, newVersion, isPublished } = {}) {
        if (isPublished && newVersion != null) return `${newVersion}`
        if (previousVersion != null && newVersion != null) return `${previousVersion} → ${newVersion}`
        return newVersion ?? previousVersion ?? "—"
    }
}
